import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { PersonLinesFill, PencilSquare, Key } from "react-bootstrap-icons";
import "./settings/styles/settings-page.css";
export default function SettingsPage() {
  const [collapsed, setCollapsed] = useState(false);

  const navItems = [
    {
      id: "view",
      to: ".",
      label: "Personal Details",
      icon: <PersonLinesFill />,
      badge: null,
    },
    {
      id: "edit",
      to: "edit",
      label: "Edit Profile",
      icon: <PencilSquare />,
      badge: null,
    },
    {
      id: "change-password",
      to: "change-password",
      label: "Change Password",
      icon: <Key />,
      badge: null,
    },
  ];

  return (
    <div className="settings-page container-fluid py-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h2 className="h4 mb-0">System Settings</h2>
          <div className="text-muted small">
            Manage your account and personal information
          </div>
        </div>

        <button
          className="btn btn-sm btn-outline-secondary d-lg-none"
          aria-expanded={!collapsed}
          aria-controls="settings-nav"
          onClick={() => setCollapsed((c) => !c)}
          title="Toggle settings navigation"
        >
          {collapsed ? "Open" : "Close"} menu
        </button>
      </div>

      <div className="row gx-4">
        {/* NAV */}
        <aside
          className={`col-lg-3 mb-3 mb-lg-0 ${collapsed ? "collapsed" : ""}`}
          id="settings-nav"
        >
          <nav className="card shadow-sm sticky-top" style={{ top: 16 }}>
            <div className="card-body p-2">
              <ol className="nav-list list-unstyled mb-0">
                {navItems.map((item) => (
                  <li key={item.id} className="mb-2">
                    <NavLink
                      to={item.to}
                      end={item.to === "."}
                      className={({ isActive }) =>
                        `nav-pill d-flex align-items-center gap-2 px-3 py-2 rounded ${isActive ? "active" : "text-muted"}`
                      }
                      aria-current={undefined}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      <span className="nav-label">{item.label}</span>
                      {item.badge && (
                        <span className="badge bg-info text-dark ms-auto small">
                          {item.badge}
                        </span>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ol>
            </div>
          </nav>

          <div className="mt-3 d-none d-lg-block small text-muted px-2">
            <strong>Tip:</strong> Use the links to view or update your profile
            and change your password.
          </div>
        </aside>

        {/* CONTENT */}
        <main className="col-lg-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="mb-3 d-flex align-items-center justify-content-between">
                <h3 className="h6 mb-0">Account settings</h3>
                <div className="small text-muted">Secure · Private</div>
              </div>

              <hr />

              <section aria-live="polite">
                <Outlet />
              </section>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
